// Per-action color scheme for the swap/move flow — kept in one place so the
// dialog's panel chips and the canvas rects stay in sync. Lives in its own
// module (not the dialog component file) so component files export only
// components, keeping React Fast Refresh working.
export const SWAP_MOVE_COLORS = {
  swap: {
    source: { fill: "rgba(134, 239, 172, 0.35)", border: "#86efac", label: "#166534", chip: "#f0fdf4", chipBorder: "#bbf7d0" },
    target: { fill: "rgba(16, 185, 129, 0.22)", border: "#10b981", border2: "dashed", label: "#065f46", chip: "#ecfdf5", chipBorder: "#a7f3d0" },
    accent: "#10b981",
    accentLight: "#f0fdf4",
    accentBorder: "#86efac",
  },
  // Move: the counter officers leave (existing) is Amber, the one they land on
  // (new) is Teal. Same pair everywhere a move is shown — dialog chips, grid
  // overlays, row labels, banners and the drag-to-move confirm bar. The pale
  // brand fills (#FFF3D6 / #DDF7F0) are the chips; the grid overlay uses them
  // semi-transparent so cell contents show through, with a stronger border.
  move: {
    source: { fill: "rgba(255, 243, 214, 0.78)", border: "#E3A72F", label: "#7A4F00", chip: "#FFF3D6", chipBorder: "#F2D48C" },
    target: { fill: "rgba(221, 247, 240, 0.78)", border: "#2BAE96", label: "#0B5C4D", chip: "#DDF7F0", chipBorder: "#A5E3D5" },
    accent: "#188F7A",
    accentLight: "#DDF7F0",
    accentBorder: "#A5E3D5",
  },
};
